RivalIQ.apps.Overview.module('config', function (config, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    const charts = {};
    const CompareData = RivalIQ.data.CompareData;

    const abbreviatedMetricFormat = function (compareData, spec) {
        return compareData.getMetricShortName(spec.metric);
    };

    const relativeSecondaryColor = function (v) {
        if (v < 0) {
            return 'rgb(255, 103, 55)';
        } else if (Number(v) === 0) {
            return '#424242';
        } else {
            return '#3eb78c';
        }
    };

    const percentFormat = '+0,.1%';

    const customAbbreviatedFormat = function (format) {
        return function (v) {
            let effectiveFormat = format;

            if (_.isFunction(format)) {
                effectiveFormat = format(v);
            }

            return (v === null) ? '--' : RivalIQ.formatter.formatAbbreviated(v, effectiveFormat);
        };
    };

    const intFormat = customAbbreviatedFormat(',.0f');

    function perDiemFormat(timePeriod, value) {
        if (value === null) {
            return '';
        }

        const perDiemValue = value / timePeriod.mainPeriodDuration;
        return `${d3.format(',.1f')(perDiemValue)}/day`;
    }

    const perDiem = {
        companyValue: perDiemFormat,
        landscapeValue: perDiemFormat
    };

    const metricSourceIcon = function (compareData, metrics) {
        const metric = _.head(metrics).metric;
        const source = compareData.getMetricSource(metric);
        const sourceDetails = compareData.getSourceDetails(source);
        return sourceDetails.fontIcon;
    };

    const isCrossChannelMetricActive = function () {

        const metric = _.get(this, 'metric', _.get(_.head(_.get(this, 'metrics')), 'metric'));
        const description = _.find(RivalIQ.metrics.descriptions, {
            id: metric
        });

        return RivalIQ.state.landscape.channelAccess(description.source);
    };

    const detailsTitle = function (compareData, metrics) {
        return compareData.getMetricAbbreviatedName(_.head(metrics).metric);
    };

    const detailsSubtitle = function (compareData, metrics, focusCompany, companySetDescriptor, companyData) {
        const metric = _.head(metrics).metric;
        const companiesToShow = companyData.getCompanyIdsByCompanySet(companySetDescriptor);
        const currentRank = compareData.getCompanyRankCurr(metric, focusCompany.id, companiesToShow);
        const isMissing = !compareData.hasChannelByConcept(metric, focusCompany.id);

        if (currentRank) {
            return `${Number(currentRank.rank).ordinal()} of ${currentRank.totalItems}`;
        } else if (isMissing) {
            return 'Not Present';
        } else {
            return 'Incomplete Data';
        }
    };

    config[CompareData.channels.CROSS_CHANNEL] = {
        contentTypeName: 'Posts',
        menuConfig: 'CROSS_CHANNEL',
        sections: {
            reach: {
                title: 'Social Audience',
                information: RivalIQ.strings.cross_channel_reach_section_info,
                graphs: [
                    {
                        title: 'Social Audience',
                        format: intFormat,
                        legend: true,
                        masterMetric: CompareData.metrics.CROSS_CHANNEL_AUDIENCE,
                        metrics: [
                            {
                                class: 'x-facebook',
                                metric: CompareData.metrics.FACEBOOK_LIKES,
                                active: isCrossChannelMetricActive
                            },
                            {
                                class: 'x-instagram',
                                metric: CompareData.metrics.INSTAGRAM_FOLLOWED_BY,
                                active: isCrossChannelMetricActive
                            },
                            {
                                class: 'x-twitter',
                                metric: CompareData.metrics.TWITTER_FOLLOWERS,
                                active: isCrossChannelMetricActive
                            },
                            {
                                class: 'x-youtube',
                                metric: CompareData.metrics.YOUTUBE_SUBSCRIBERS,
                                active: isCrossChannelMetricActive
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.CROSS_CHANNEL_AUDIENCE
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'presence_reach'
                                }
                            }
                        }
                    }
                ],
                details: {
                    title: detailsTitle,
                    subtitle: detailsSubtitle,
                    subject: RivalIQ.strings.overview_social_audience_section_subject,
                    icon: metricSourceIcon,
                    format: intFormat,
                    graphs: [
                        {
                            metrics: [
                                {
                                    class: 'x-facebook',
                                    metric: CompareData.metrics.FACEBOOK_LIKES
                                }
                            ],
                            metricDetail: {
                                format: percentFormat,
                                color: relativeSecondaryColor,
                                metric: CompareData.metrics.FACEBOOK_LIKES
                            },
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'presence_reach',
                                        channel: 'facebook'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        },
                        {
                            metrics: [
                                {
                                    class: 'x-instagram',
                                    metric: CompareData.metrics.INSTAGRAM_FOLLOWED_BY
                                }
                            ],
                            metricDetail: {
                                format: percentFormat,
                                color: relativeSecondaryColor,
                                metric: CompareData.metrics.INSTAGRAM_FOLLOWED_BY
                            },
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'presence_reach',
                                        channel: 'instagram'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        },
                        {
                            metrics: [
                                {
                                    class: 'x-twitter',
                                    metric: CompareData.metrics.TWITTER_FOLLOWERS
                                }
                            ],
                            metricDetail: {
                                format: percentFormat,
                                color: relativeSecondaryColor,
                                metric: CompareData.metrics.TWITTER_FOLLOWERS
                            },
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'presence_reach',
                                        channel: 'twitter'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        },
                        {
                            metrics: [
                                {
                                    class: 'x-youtube',
                                    metric: CompareData.metrics.YOUTUBE_SUBSCRIBERS
                                }
                            ],
                            metricDetail: {
                                format: percentFormat,
                                color: relativeSecondaryColor,
                                metric: CompareData.metrics.YOUTUBE_SUBSCRIBERS
                            },
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'presence_reach',
                                        channel: 'youtube'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        }
                    ]
                }
            },
            activity: {
                title: 'Social Activity',
                information: RivalIQ.strings.cross_channel_activity_section_info,
                graphs: [
                    {
                        title: 'Social Activity',
                        format: intFormat,
                        legend: true,
                        masterMetric: CompareData.metrics.CROSS_CHANNEL_ACTIVITY,
                        metrics: [
                            {
                                class: 'x-facebook',
                                metric: CompareData.metrics.FACEBOOK_POSTS,
                                active: isCrossChannelMetricActive
                            },
                            {
                                class: 'x-instagram',
                                metric: CompareData.metrics.INSTAGRAM_POSTS,
                                active: isCrossChannelMetricActive
                            },
                            {
                                class: 'x-twitter',
                                metric: CompareData.metrics.TWITTER_NORMAL_TWEETS,
                                active: isCrossChannelMetricActive
                            },
                            {
                                class: 'x-youtube',
                                metric: CompareData.metrics.YOUTUBE_POSTS,
                                active: isCrossChannelMetricActive
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.CROSS_CHANNEL_ACTIVITY
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'count'
                                }
                            }
                        }
                    }
                ],
                details: {
                    title: detailsTitle,
                    subtitle: detailsSubtitle,
                    subject: RivalIQ.strings.overview_social_activity_section_subject,
                    icon: metricSourceIcon,
                    format: intFormat,
                    graphs: [
                        {
                            metrics: [
                                {
                                    class: 'x-facebook',
                                    metric: CompareData.metrics.FACEBOOK_POSTS
                                }
                            ],
                            metricDetail: _.extend({
                                metric: CompareData.metrics.FACEBOOK_POSTS
                            }, perDiem),
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'count',
                                        channel: 'facebook'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        },
                        {
                            metrics: [
                                {
                                    class: 'x-instagram',
                                    metric: CompareData.metrics.INSTAGRAM_POSTS
                                }
                            ],
                            metricDetail: _.extend({
                                metric: CompareData.metrics.INSTAGRAM_POSTS
                            }, perDiem),
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'count',
                                        channel: 'instagram'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        },
                        {
                            metrics: [
                                {
                                    class: 'x-twitter',
                                    metric: CompareData.metrics.TWITTER_NORMAL_TWEETS
                                }
                            ],
                            metricDetail: _.extend({
                                metric: CompareData.metrics.TWITTER_NORMAL_TWEETS
                            }, perDiem),
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'count',
                                        channel: 'twitter'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        },
                        {
                            metrics: [
                                {
                                    class: 'x-youtube',
                                    metric: CompareData.metrics.YOUTUBE_POSTS
                                }
                            ],
                            metricDetail: _.extend({
                                metric: CompareData.metrics.YOUTUBE_POSTS
                            }, perDiem),
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'count',
                                        channel: 'youtube'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        }
                    ]
                }
            },
            engagement: {
                title: 'Social Engagement',
                information: RivalIQ.strings.cross_channel_engagement_section_info,
                graphs: [
                    {
                        title: 'Total Social Engagement',
                        format: intFormat,
                        legend: true,
                        masterMetric: CompareData.metrics.CROSS_CHANNEL_ENGAGEMENT,
                        metrics: [
                            {
                                class: 'x-facebook',
                                metric: CompareData.metrics.FACEBOOK_POSTS_ENGAGEMENT_TOTAL,
                                active: isCrossChannelMetricActive
                            },
                            {
                                class: 'x-instagram',
                                metric: CompareData.metrics.INSTAGRAM_POSTS_ENGAGEMENT_TOTAL,
                                active: isCrossChannelMetricActive
                            },
                            {
                                class: 'x-twitter',
                                metric: CompareData.metrics.TWITTER_TWEETS_ENGAGEMENT_TOTAL,
                                active: isCrossChannelMetricActive
                            },
                            {
                                class: 'x-youtube',
                                metric: CompareData.metrics.YOUTUBE_POSTS_ENGAGEMENT_TOTAL,
                                active: isCrossChannelMetricActive
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.CROSS_CHANNEL_ENGAGEMENT
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'engagement_total'
                                }
                            }
                        }
                    }
                ],
                details: {
                    title: detailsTitle,
                    subtitle: detailsSubtitle,
                    subject: RivalIQ.strings.overview_social_engagement_section_subject,
                    icon: metricSourceIcon,
                    format: intFormat,
                    graphs: [
                        {
                            metrics: [
                                {
                                    class: 'x-facebook',
                                    metric: CompareData.metrics.FACEBOOK_POSTS_ENGAGEMENT_TOTAL
                                }
                            ],
                            metricDetail: {
                                format: percentFormat,
                                color: relativeSecondaryColor,
                                metric: CompareData.metrics.FACEBOOK_POSTS_ENGAGEMENT_TOTAL
                            },
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'engagement_total',
                                        channel: 'facebook',
                                        dimensions: 'engagement_type'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        },
                        {
                            metrics: [
                                {
                                    class: 'x-instagram',
                                    metric: CompareData.metrics.INSTAGRAM_POSTS_ENGAGEMENT_TOTAL
                                }
                            ],
                            metricDetail: {
                                format: percentFormat,
                                color: relativeSecondaryColor,
                                metric: CompareData.metrics.INSTAGRAM_POSTS_ENGAGEMENT_TOTAL
                            },
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'engagement_total',
                                        channel: 'instagram',
                                        dimensions: 'engagement_type'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        },
                        {
                            metrics: [
                                {
                                    class: 'x-twitter',
                                    metric: CompareData.metrics.TWITTER_TWEETS_ENGAGEMENT_TOTAL
                                }
                            ],
                            metricDetail: {
                                format: percentFormat,
                                color: relativeSecondaryColor,
                                metric: CompareData.metrics.TWITTER_TWEETS_ENGAGEMENT_TOTAL
                            },
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'engagement_total',
                                        channel: 'twitter',
                                        dimensions: 'engagement_type'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        },
                        {
                            metrics: [
                                {
                                    class: 'x-youtube',
                                    metric: CompareData.metrics.YOUTUBE_POSTS_ENGAGEMENT_TOTAL
                                }
                            ],
                            metricDetail: {
                                format: percentFormat,
                                color: relativeSecondaryColor,
                                metric: CompareData.metrics.YOUTUBE_POSTS_ENGAGEMENT_TOTAL
                            },
                            analyze: {
                                footer: {
                                    metric: {
                                        property: 'engagement_total',
                                        channel: 'youtube',
                                        dimensions: 'engagement_type'
                                    }
                                }
                            },
                            active: isCrossChannelMetricActive
                        }
                    ]
                }
            },
            topSocialContent: {
                charts: function () {
                    const isCrossChannel = RivalIQ.state.view.get('contentChannel') === 'cross_channel';
                    return [
                        charts.COMPANY,
                        (isCrossChannel ? charts.CHANNEL : charts.TYPE),
                        charts.DAY
                    ];
                }
            }
        }
    };

    config[CompareData.channels.TWITTER] = {
        contentTypeName: 'Tweets',
        menuConfig: 'TWITTER',
        sections: {
            reach: {
                title: 'Followers',
                information: RivalIQ.strings.reach_section_info,
                graphs: [
                    {
                        title: 'Followers',
                        format: intFormat,
                        metrics: [
                            {
                                class: 'x-twitter',
                                metric: CompareData.metrics.TWITTER_FOLLOWERS
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.TWITTER_FOLLOWERS
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'presence_reach',
                                    channel: 'twitter'
                                }
                            }
                        }
                    }
                ]
            },
            activity: {
                title: 'Activity & Engagement',
                information: RivalIQ.strings.activity_section_info,
                observationType: 'activityAndEngagement',
                graphs: [
                    {
                        title: 'All Tweets',
                        format: intFormat,
                        legend: true,
                        metrics: [
                            {
                                class: 'x-twitter',
                                metric: CompareData.metrics.TWITTER_NORMAL_TWEETS,
                                name: abbreviatedMetricFormat
                            },
                            {
                                class: 'x-twitter-secondary',
                                metric: CompareData.metrics.TWITTER_RETWEET_TWEETS,
                                name: abbreviatedMetricFormat
                            },
                            {
                                class: 'x-twitter-tertiary',
                                metric: CompareData.metrics.TWITTER_REPLY_TWEETS,
                                name: abbreviatedMetricFormat
                            }
                        ],
                        metricDetail: _.extend({
                            metric: CompareData.metrics.TWITTER_ALL_TWEETS
                        }, perDiem),
                        analyze: {
                            header: {
                                metric: {
                                    property: 'all_count',
                                    channel: 'twitter',
                                    dimensions: ['tweetType']
                                }
                            }
                        }
                    },
                    {
                        title: 'Engagement Total',
                        format: intFormat,
                        legend: true,
                        metrics: [
                            {
                                class: 'x-twitter',
                                metric: CompareData.metrics.TWITTER_TWEETS_FAVORITES,
                                name: abbreviatedMetricFormat
                            },
                            {
                                class: 'x-twitter-secondary',
                                metric: CompareData.metrics.TWITTER_TWEETS_RETWEETS,
                                name: abbreviatedMetricFormat
                            },
                            {
                                class: 'x-twitter-tertiary',
                                metric: CompareData.metrics.TWITTER_TWEETS_REPLIES,
                                name: abbreviatedMetricFormat
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.TWITTER_TWEETS_ENGAGEMENT_TOTAL
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'engagement_total',
                                    channel: 'twitter',
                                    dimensions: ['engagement_type']
                                }
                            }
                        }
                    }
                ]
            },
            topSocialContent: {
            }
        }
    };

    config[CompareData.channels.FACEBOOK] = {
        contentTypeName: 'Posts',
        menuConfig: 'FACEBOOK',
        sections: {
            reach: {
                title: 'Page Likes',
                information: RivalIQ.strings.reach_section_info,
                graphs: [
                    {
                        title: 'Page Likes',
                        format: intFormat,
                        metrics: [
                            {
                                class: 'x-facebook',
                                metric: CompareData.metrics.FACEBOOK_LIKES
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.FACEBOOK_LIKES
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'presence_reach',
                                    channel: 'facebook'
                                }
                            }
                        }
                    }
                ]
            },
            activity: {
                title: 'Activity & Engagement',
                information: RivalIQ.strings.activity_section_info,
                observationType: 'activityAndEngagement',
                graphs: [
                    {
                        title: 'Posts',
                        format: intFormat,
                        metrics: [
                            {
                                class: 'x-facebook',
                                metric: CompareData.metrics.FACEBOOK_POSTS
                            }
                        ],
                        metricDetail: _.extend({
                            metric: CompareData.metrics.FACEBOOK_POSTS
                        }, perDiem),
                        analyze: {
                            header: {
                                metric: {
                                    property: 'count',
                                    channel: 'facebook'
                                }
                            }
                        }
                    },
                    {
                        title: 'Engagement Total',
                        format: intFormat,
                        legend: true,
                        metrics: [
                            {
                                class: 'x-facebook',
                                metric: CompareData.metrics.FACEBOOK_POSTS_REACTIONS,
                                name: abbreviatedMetricFormat
                            },
                            {
                                class: 'x-facebook-secondary',
                                metric: CompareData.metrics.FACEBOOK_POSTS_COMMENTS,
                                name: abbreviatedMetricFormat
                            },
                            {
                                class: 'x-facebook-tertiary',
                                metric: CompareData.metrics.FACEBOOK_POSTS_SHARES,
                                name: abbreviatedMetricFormat
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.FACEBOOK_POSTS_ENGAGEMENT_TOTAL
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'engagement_total',
                                    channel: 'facebook',
                                    dimensions: ['engagement_type']
                                }
                            }
                        }
                    }
                ]
            },
            topSocialContent: {

            }
        }
    };

    config[CompareData.channels.YOUTUBE] = {
        contentTypeName: 'Posts',
        menuConfig: 'YOUTUBE',
        sections: {
            reach: {
                title: 'Subscribers',
                information: RivalIQ.strings.reach_section_info,
                graphs: [
                    {
                        title: 'Subscribers',
                        format: intFormat,
                        metrics: [
                            {
                                class: 'x-youtube',
                                metric: CompareData.metrics.YOUTUBE_SUBSCRIBERS
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.YOUTUBE_SUBSCRIBERS
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'presence_reach',
                                    channel: 'youtube'
                                }
                            }
                        }
                    }
                ]
            },
            activity: {
                title: 'Activity & Engagement',
                information: RivalIQ.strings.activity_section_info,
                observationType: 'activityAndEngagement',
                graphs: [
                    {
                        title: 'Posts',
                        format: intFormat,
                        metrics: [
                            {
                                class: 'x-youtube',
                                metric: CompareData.metrics.YOUTUBE_POSTS
                            }
                        ],
                        metricDetail: _.extend({
                            metric: CompareData.metrics.YOUTUBE_POSTS
                        }, perDiem),
                        analyze: {
                            header: {
                                metric: {
                                    property: 'count',
                                    channel: 'youtube'
                                }
                            }
                        }
                    },
                    {
                        title: 'Total Engagement',
                        format: intFormat,
                        legend: true,
                        metrics: [
                            {
                                class: 'x-youtube',
                                metric: CompareData.metrics.YOUTUBE_POSTS_LIKES,
                                name: abbreviatedMetricFormat
                            },
                            {
                                class: 'x-youtube-secondary',
                                metric: CompareData.metrics.YOUTUBE_POSTS_COMMENTS,
                                name: abbreviatedMetricFormat
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.YOUTUBE_POSTS_ENGAGEMENT_TOTAL
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'engagement_total',
                                    channel: 'youtube',
                                    dimensions: ['engagement_type']
                                }
                            }
                        }
                    }
                ]
            },
            topSocialContent: {

            }
        }
    };

    config[CompareData.channels.INSTAGRAM] = {
        contentTypeName: 'Posts',
        menuConfig: 'INSTAGRAM',
        sections: {
            reach: {
                title: 'Followed By',
                information: RivalIQ.strings.reach_section_info,
                graphs: [
                    {
                        title: 'Followed By',
                        format: intFormat,
                        metrics: [
                            {
                                class: 'x-instagram',
                                metric: CompareData.metrics.INSTAGRAM_FOLLOWED_BY
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.INSTAGRAM_FOLLOWED_BY
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'presence_reach',
                                    channel: 'instagram'
                                }
                            }
                        }
                    }
                ]
            },
            activity: {
                title: 'Activity & Engagement',
                information: RivalIQ.strings.activity_section_info,
                observationType: 'activityAndEngagement',
                graphs: [
                    {
                        title: 'Posts',
                        format: intFormat,
                        metrics: [
                            {
                                class: 'x-instagram',
                                metric: CompareData.metrics.INSTAGRAM_POSTS
                            }
                        ],
                        metricDetail: _.extend({
                            metric: CompareData.metrics.INSTAGRAM_POSTS
                        }, perDiem),
                        analyze: {
                            header: {
                                metric: {
                                    property: 'count',
                                    channel: 'instagram'
                                }
                            }
                        }
                    },
                    {
                        title: 'Engagement Total',
                        format: intFormat,
                        legend: true,
                        metrics: [
                            {
                                class: 'x-instagram',
                                metric: CompareData.metrics.INSTAGRAM_POSTS_LIKES,
                                name: abbreviatedMetricFormat
                            },
                            {
                                class: 'x-instagram-secondary',
                                metric: CompareData.metrics.INSTAGRAM_POSTS_COMMENTS,
                                name: abbreviatedMetricFormat
                            }
                        ],
                        metricDetail: {
                            format: percentFormat,
                            color: relativeSecondaryColor,
                            metric: CompareData.metrics.INSTAGRAM_POSTS_ENGAGEMENT_TOTAL
                        },
                        analyze: {
                            header: {
                                metric: {
                                    property: 'engagement_total',
                                    channel: 'instagram',
                                    dimensions: ['engagement_type']
                                }
                            }
                        }
                    }
                ]
            },
            topSocialContent: {

            }
        }
    };

    config.getSection = function (channel, section) {
        if (!channel) {
            channel = CompareData.channels.CROSS_CHANNEL;
        }

        return config[channel].sections[section];
    };

}, window.d3);
